import CalendarIcon from '../../../Icons/CalendarIcon';
import React from 'react';
import css from './DateInput.module.css';
import classNames from 'classnames';

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputClassNameWrapper?: string;
    iconClassName?: string;
    showIcon?: boolean;
    disabled?: boolean;
}

const DateInput: React.FC<DateInputProps> = ({
    inputClassNameWrapper = css.inputWrapper,
    iconClassName = css.icon,
    showIcon = true,
    className = css.input,
    disabled = false,
    ...props
}) => {
    const handleIconClick = () => {
        if (disabled) {
            return;
        }
        const input = document.querySelector(
            `.${inputClassNameWrapper} input`
        ) as HTMLInputElement;
        input?.focus();
        input?.showPicker?.();
    };

    return (
        <div
            className={`${inputClassNameWrapper} ${disabled && css.disabledWrapper}`}
        >
            <input
                type="date"
                className={className}
                disabled={disabled}
                {...props}
            />
            {showIcon && (
                <div
                    className={classNames(iconClassName, css.disabledIcon)}
                    onClick={handleIconClick}
                >
                    <CalendarIcon
                        width={20}
                        height={20}
                        stroke={'currentColor'}
                        className={css.iconSvg}
                    />
                </div>
            )}
        </div>
    );
};

export default React.memo(DateInput);
